<!-- 
 * @description: toast模块
 * @fileName: template.vue 
 * @author: 薛微微 
 * @date: 2023-06-19 17:00:16
!-->
<template>
  <p
    id="toast"
    class="rastar-toast"
    :class="[
      active ? 'active' : '',
      this.$Base.checkSysteam() == 'MOBILE' ? 'mrastar-toast' : 'rastar-toast',
    ]"
  >
    {{ text }}
  </p>
</template>

<script>
export default {
  name: "RastarToast",
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
